// extracted by mini-css-extract-plugin
export default {"scroll":"Slider_scroll__oP55z","button":"Slider_button__wCsJs"};